import * as React from "react";
import type { SVGProps } from "react";
const SvgPieChart02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M11.435 21.883a9.035 9.035 0 0 0 9.036-9.036h-9.036V3.812a9.035 9.035 0 0 0 0 18.07"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15.388 2.118v6.69H21.6v-.479a6.21 6.21 0 0 0-6.212-6.211"
    />
  </svg>
);
export default SvgPieChart02;
